import { string, StringSchema } from 'yup';

import { validationErrMessages } from '@constants/validationConstants';

export const nameValidation = (
	fieldName: string,
	minLength: number = 2,
	maxLength: number = 100,
): StringSchema<string> =>
	string()
		.trim()
		.default('')
		.min(minLength, `${fieldName} must be at least ${minLength} characters`)
		.max(maxLength, `${fieldName} must be at most ${maxLength} characters`)
		.matches(
			/^[A-Za-zÀ-ÖØ-öø-ÿ'-. ]*$/,
			`${fieldName} can only contain letters, spaces, hyphens, apostrophes, periods, and accented characters`,
		)
		.test('noExcessiveWhitespace', `${fieldName} cannot contain excessive whitespace`, (value) => {
			return typeof value === 'string' && !/\s{2,}/.test(value);
		})
		.required(validationErrMessages[fieldName.toLowerCase() as keyof typeof validationErrMessages]);
